export enum AppState {
  Booting = 'BOOTING',
  Loading = 'LOADING',
  Intro = 'INTRO',
  Ready = 'READY',
  Playing = 'PLAYING',
  Hit = 'HIT',
  Paused = 'PAUSED',
  GameOver = 'GAME_OVER',
  Restarting = 'RESTARTING',
}
